import { Box, Button } from "@mui/material";
import BoltIcon from "@mui/icons-material/Bolt";
import { useState } from "react";
import { StatefulDialog } from "./statefulConfirmationDialog";
import { useEmergencyMode } from "./mutations";

const ControlButtons = () => {
  const { mutateAsync: enableEmergencyMode } = useEmergencyMode();
  const [open, setOpen] = useState(false);
  return (
    <Box display={"flex"}>
      <Button
        startIcon={<BoltIcon />}
        variant="contained"
        onClick={() => setOpen(true)}
        color="error"
      >
        Emergency stop
      </Button>
      <StatefulDialog
        open={open}
        setOpen={setOpen}
        displayValues={{
          title: "Emergency Stop LazerTrader",
          body: "Put JEPX into emergency mode? Every algo running on it will be stopped. Clear it again from the JEPX indicator in the navbar.",
          loading: "Enabling emergency mode...",
          confirm: "Yes",
          cancel: "No",
        }}
        apiRequest={() => enableEmergencyMode()}
      />
    </Box>
  );
};

export { ControlButtons };
